import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class MovimentacoesPartService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public listar(filtro: any){

    return this.http
               .get(`${environment.apiURL}/Logado/MovimentacoesPart/Listar`, {params: filtro})
  }

  public filtrar(anomesInicio,anomesFim,tipoFundo,tipoOrdem){
    return this.http
               .get(`${environment.apiURL}/Logado/MovimentacoesPart/Filtrar`,{params:{anomesInicio:anomesInicio,anomesFim:anomesFim,tipoFundo:tipoFundo,tipoOrdem:tipoOrdem}})
  }

  public listarFiltros(){
      return this.http
                 .get(`${environment.apiURL}/Logado/MovimentacoesPart/ListarFiltros`)
  }

  public salvaAporte(valor,data){
    return this.http
               .get(`${environment.apiURL}/Logado/Aporte/GerarBoleto`,{params:{valor:valor,data:data}})
  }

  public buscaDadosSaldos(){
    return this.http
               .get(`${environment.apiURL}/Logado/MovimentacoesPart/BuscaDadosSaldos`)
  }


  public verificaEleicao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Eleicao/VerificaEleicoes`)
  }

}
